/**
 * There is exactly one edition.
 *
 * Upstream is split-licensed and its enterprise tree has been removed from
 * this fork, so there is no licence to fetch, no plan to compare against and
 * no upgrade to sell. Upstream branches on four booleans to decide whether a
 * screen shows the product or an upsell; pinning them here turns every one of
 * those branches into "you already have it" without editing the call sites.
 *
 * `isCommunityUser` is the branch upstream uses for a self-hosted install with
 * no licensing endpoint, which is exactly what we run.
 */
export const TENANT_EDITION = {
	isCloudUser: false,
	isEnterpriseSelfHostedUser: false,
	isCommunityUser: true,
	isCommunityEnterpriseUser: false,
} as const;
